module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/protocolos/protocolos.component.css
// module id = ./src/app/protocolos/protocolos.component.css
// module chunks = main